import useMountEffect from '@restart/hooks/useMountEffect';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

import actions from '@/actions';
import EventEmitter from '@/libs/EventEmitter';
import telemetryStore from '@/stores/telemetryStore';

const useWaitingRobot = (robotId) => {
  const dispatch = useDispatch();
  const [isWaiting, setIsWaiting] = useState(true);

  useMountEffect(() => {
    EventEmitter.subscribe(`${robotId}/event/waitingRobot`, () => {
      setIsWaiting(true);
    });

    EventEmitter.subscribe(`${robotId}/event/reconnectRobot`, () => {
      setIsWaiting(false);
    });

    EventEmitter.subscribe(`${robotId}/event/disconnectRobot`, () => {
      dispatch(actions.robots.deactivate(robotId));
      dispatch(actions.address.remove(robotId));
      dispatch(actions.robotOptions.remove(robotId));
      dispatch(actions.robotParams.remove(robotId));
      telemetryStore.remove(robotId);
      dispatch(actions.missions.remove(robotId));
      dispatch(actions.notifications.remove(robotId));
    });
  });

  return isWaiting;
};

export default useWaitingRobot;
